import React, {memo} from 'react';
import Svg, {Path} from 'react-native-svg';

export const IconChangePassword = memo(({color = '#000', size = 24, ...rest}) => {
    return (
        <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
            <Path fill={color}
                  d="M17 7h5v10h-5v2a1 1 0 001 1h2v2h-2.5c-.55 0-1.5-.45-1.5-1 0 .55-.95 1-1.5 1H12v-2h2a1 1 0 001-1V5a1 1 0 00-1-1h-2V2h2.5c.55 0 1.5.45 1.5 1 0-.55.95-1 1.5-1H20v2h-2a1 1 0 00-1 1v2M2 7h11v2H4v6h9v2H2V7m18 8V9h-3v6h3M8.5 12A1.5 1.5 0 007 10.5 1.5 1.5 0 005.5 12 1.5 1.5 0 007 13.5 1.5 1.5 0 008.5 12m4.5-1.11c-.61-.56-1.56-.51-2.12.11-.56.6-.51 1.55.12 2.11.55.52 1.43.52 2 0v-2.22z"/>
        </Svg>
    );
});
